<template>
  <div>
    <el-badge :is-dot="hasNotice">
      <i class="el-icon-bell" @click="click" />
    </el-badge>
  </div>
</template>

<script>
import { getNotice } from '@/api/profile'

export default {
  data() {
    return {
      hasNotice: false,
      timer: ''
    }
  },
  mounted() {
    this.timer = setInterval(this.checkNotice, 30 * 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  created() {
    this.checkNotice()
  },
  methods: {
    click() {
      this.$router.push({ path: '/profile/notice' })
    },
    checkNotice() {
      if (this.hasNotice) {
        return
      }
      getNotice().then(response => {
        // 兼容不同的返回格式
        const data = response.data
        if (data && typeof data === 'number') {
          this.hasNotice = data > 0
        } else if (data && data.data !== undefined) {
          this.hasNotice = data.data > 0
        } else {
          this.hasNotice = false
        }
      }).catch(() => {
        this.hasNotice = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-badge__content.is-fixed.is-dot {
  right: 5px;
  top: 10px;
}

.el-icon-bell {
  font-size: 20px;
  cursor: pointer;
}
</style>
